<template>
  <div class="dify-chat">
    <!-- 移动端头部导航栏 -->
    <MobileHeader
        :title="currentConversationTitle"
        @settingsSaveClick="settingsSaveClick"
        @toggle-drawer="toggleMobileDrawer"
        @new-chat="handleNewChat"
    />

    <!-- 移动端抽屉 -->
    <MobileDrawer
        :active-conversation="activeConversation"
        :collapsed_ids="collapsed_ids"
        :conversation-list="conversationList"
        :custom-menu="customMenu"
        :is-loading-conversations="isLoadingConversations"
        :profile_info="profile_info"
        :visible="isMobileDrawerVisible"
        @agentOpen="agentOpen"
        @close="toggleMobileDrawer"
        @new-chat="handleNewChat"
        @conversation-change="handleConversationChange"
        @delete-conversation="handleDeleteConversation"
        @menu-command="handleMenuCommand"
    />

    <div class="dify-main">
      <!-- 桌面端侧边栏 -->
      <Sidebar
          :active-conversation="activeConversation"
          :collapsed_ids="collapsed_ids"
          :conversation-list="conversationList"
          :is-loading-conversations="isLoadingConversations"
          :is-side-collapsed="isSideCollapsed"
          :profile_info="profile_info"
          @agentOpen="agentOpen"
          @toggle="toggleSideMenu"
          @new-chat="handleNewChat"
          @conversation-change="handleConversationChange"
          @menu-command="handleMenuCommand"
      />

      <!-- 聊天容器 -->
      <ChatContainer
          ref="chatContainer"
          :agent_list="agent_list"
          :chat_id="parseInt(chat_id)"
          :class="{ collapsed: isSideCollapsed }"
          :client_id="client_id"
          :dify-config="difyConfig"
          :is-loading-messages="isLoadingMessages"
          :is-loading-suggestions="isLoadingSuggestions"
          :is-select="isSelect"
          :loading="loading"
          :map-file-type="mapFileType"
          :model-conversations="modelConversations"
          :model_role_enable="model_role_enable"
          :models="models"
          :robot="robot"
          :robot_id="parseInt(robot_id)"
          :sender-value="senderValue"
          :show-suggested-questions="showSuggestedQuestions"
          :showAgentUI="showAgentUI"
          :suggested-questions="suggestedQuestions"
          :summary_status="summary_status"
          :title="modelConversations.length > 0 ? currentConversationTitle : ''"
          :uploaded-files="uploadedFiles"
          @agentBack="agentBack"
          @agentOpen="agentOpen"
          @modelSelectEvent="modelSelectEvent"
          @onLoadMore="onLoadMore"
          @send="handleSendMessage"
          @stop="handleStopMessage"
          @column-send="handleColumnSend"
          @edit-title="handleEditTitle"
          @edit-message="handleEditMessage"
          @retry-message="handleRetryMessage"
          @update-feedback="handleUpdateFeedback"
          @share-click="handleShareMessage"
          @prompt-click="handlePromptItemClick"
          @suggested-question-click="handleSuggestedQuestionClick"
          @update-workflow-active="handleUpdateWorkflowActive"
          @update-node-active="handleUpdateNodeActive"
          @file-upload="handleFileUpload"
          @file-drop="handleFileDrop"
          @delete-file="handleDeleteUploadedFile"
          @update:is-select="value => (isSelect = value)"
          @update:sender-value="value => (senderValue = value)"
          @summary-click="summaryClick"
      />
    </div>

    <!-- 隐藏的文件上传输入框 -->
    <input
        ref="fileInput"
        style="display: none"
        type="file"
        @change="handleFileInputChange"
    />

    <!-- 分享弹窗：列标题分享 / 侧边栏分享共用 -->
    <el-dialog
        :append-to-body="true"
        :visible.sync="shareDialogVisible"
        class="share-dialog"
        title="分享链接"
        top="30vh"
        width="500px"
        @closed="shareDialogVisible = false"
    >
      <div class="share-content">
        <el-form
            label-width="90px"
        >
          <el-form-item label="失效时间：">
            <el-radio-group v-model="shareExpireDay">
              <el-radio :label="1">1天</el-radio>
              <el-radio :label="7">7天</el-radio>
              <el-radio :label="0">永久</el-radio>
            </el-radio-group>
            <div class="share-tip">有效期内可见会话更新</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="share-btn-wrap">
          <el-button size="small" @click="shareDialogVisible = false">取 消</el-button>

          <el-button class="share-copy-btn" size="small" type="primary" @click="copyShareUrl">
            分享并复制链接
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {sendMixin, streamMixin} from 'vue-element-ui-x';

// 导入新组件
import ChatContainer from './components/ChatContainer.vue';
import MobileDrawer from './components/MobileDrawer.vue';
import MobileHeader from './components/MobileHeader.vue';
import Sidebar from './components/Sidebar.vue';

// 导入mixins
import conversationMixin from './mixins/conversationMixin';
import fileMixin from './mixins/fileMixin';
import messageMixin from './mixins/messageMixin';
import responsiveMixin from './mixins/responsiveMixin';
import {profile_index} from "@/api/login";
import {all_robot_list, chat_detail} from "@/api/chat"

export default {
  name: 'DifyChat',
  components: {
    MobileHeader,
    MobileDrawer,
    Sidebar,
    ChatContainer,
  },
  mixins: [sendMixin, streamMixin, responsiveMixin, conversationMixin, messageMixin, fileMixin],

  data() {
    return {
      // 主组件特有的数据
      loading: false,
      // Dify 配置保留在主组件，但其他数据应该在mixins中
      profile_info: {},
      showAgentUI: false,
      agent_list: [],//智能体列表
      // 智能体ID
      robot_id: 0,
      robot: {
        allow_read: '0',
        desc: '',
        name: '',
        id: '',
        voice_id: ''
      },
      models: [],
      params_models: [],
      model_ids: '',//模型IDs集合
      model_role_enable: false,
      // 会话id
      chat_id: 0,
      client_id: '',
      summary_status: false,
      shareExpireDay: 1
    };
  },

  async mounted() {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    //获取缓存里面记录的智能体id
    let robot_id = localStorage.getItem('robot_id');
    if (robot_id > 0) {
      this.robot_id = robot_id
    }
    await this.loadConversations();
    await this.profile_index()
  },
  beforeDestroy() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  },

  methods: {
    // 模型选择回调
    modelSelectEvent(e) {
      this.params_models = e
      if (e && e.length) {
        this.model_ids = e.map(item => item.model_id).join(',')
      } else {
        // 取消全部选择时清空 model_ids
        this.model_ids = ''
      }
      // 重新加载消息
      this.modelConversations = []
      this.onLoadMore()
    },
    chat_detail() {
      chat_detail(
          {
            chat_id: this.chat_id,
            robot_id: this.robot_id
          }
      ).then(res => {
        this.robot_id = res.result.current_robot_id
        this.models = res.result.models
        this.params_models = res.result.models
        this.model_role_enable = res.result.model_role_enable
        this.summary_status = false
        this.robot = res.result.robot
      }).catch(err => {
      })
    },
    // 智能体返回回调
    agentBack(e) {
      if (e) {
        this.senderValue = '' //清空输入框内容
        this.robot_id = e
        localStorage.setItem('robot_id', this.robot_id)
        this.chat_id = 0
        this.uploadedFiles = []
        this.model_ids = ''
        this.modelConversations = []
        this.chat_detail()
        this.onLoadMore()
        this.showAgentUI = false;
      } else {
        this.showAgentUI = false;
      }
    },
    //打开智能体列表
    agentOpen() {
      this.showAgentUI = true;
    },
    // 智能体列表
    all_robot_list() {
      all_robot_list().then(response => {
        this.agent_list = response.result.rows
      }).catch(error => {
      })
    },
    // 个人信息设置刷新接口
    settingsSaveClick() {
      this.profile_index()
    },
    // 用户信息
    profile_index() {
      profile_index().then(res => {
        this.profile_info = res.result
        this.showAgentUI = res.result.last_chat_id == 0
        this.chat_detail()
        this.all_robot_list()
        this.onLoadMore()
      }).catch(err => {
      })
    },
    // 触发文件上传选择
    handleFileUpload() {
      this.$refs.fileInput.click();
    },

    // 处理拖拽文件上传
    handleFileDrop(files) {
      // 遍历处理文件
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          this.handleFileChange(files[i]);
        }
      }
    },

    // 处理文件输入框变化
    handleFileInputChange(event) {
      const file = event.target.files[0];
      if (file) {
        // 调用fileMixin的handleFileChange方法
        this.handleFileChange(file);
      }
      // 清空文件输入
      event.target.value = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './index.scss';

.dify-chat {
  height: 100vh;
  overflow: hidden;

  .dify-main {
    display: flex;
    height: 100vh;


  }
}

// 分享弹窗样式
.share-content {
  padding: 5px 0;

  // 失效时间下方的提示文案
  .share-tip {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    margin-top: 6px;
  }

  // 复制按钮与链接输入框左对齐（90px = 表单 label 宽度）
  .share-btn-wrap {
    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.share-dialog {
  ::v-deep .el-dialog__body {
    padding: 16px 20px;
  }
}
</style>
